import * as tslib_1 from "tslib";
import { Component } from "vue-property-decorator";
import { BaseControl } from "@cloudpivot/form/src/common/controls/base-control";
import { UploadControl } from "@cloudpivot/form/src/common/controls/upload-control";
import Signatrue from "./signatrue.vue";
let InputSignsture = class InputSignsture extends BaseControl {
    constructor() {
        super(...arguments);
        this.bs64Img = '';
    }
    handleValueChange() {
        this.setBs64Img();
    }
    setControl() {
        // if (!this.ctrl.value[0]) return;
        // this.bs64Img =  UploadControl.service.getDownloadUrl(this.ctrl.value[0]);
        this.setBs64Img();
    }
    setBs64Img() {
        const val = this.ctrl.value;
        if (val && val.length > 0) {
            let fileObj = "";
            if (val[0].url) {
                fileObj = val.find((f) => {
                    let mimeType = f.name.split('.')[1] || '';
                    return ["jpg", "jpeg", "png", "gif", "bmp", "svg", "tif"].includes(mimeType);
                });
                this.bs64Img = fileObj.url;
                return;
            }
            if (val[0].mimeType) {
                fileObj = val.find((f) => f.mimeType.indexOf('image') > -1);
                this.bs64Img = UploadControl.service.getDownloadUrl(fileObj);
            }
        }
        else {
            this.bs64Img = '';
        }
    }
    /**
    * 图片预览
    */
    previewImage(file) {
        // UploadControl.service.download(this.ctrl.value[0]);
        if (this.ctrl && this.ctrl.value && this.ctrl.value[0]) {
            const url = UploadControl.service.getPreviewUrl(this.ctrl.value[0]);
            url && window.open(url);
        }
    }
    upLoad(file) {
        if (!file) {
            this.ctrl.value = null;
            return;
        }
        UploadControl.service.upFile(file).then((res) => {
            if (res.errcode === 0) {
                this.ctrl.value = [];
                this.ctrl.value.push(res.data);
            }
        });
        // 清除多余样式
        setTimeout(() => {
            document.body.style.overflow = "";
            document.body.style.top = "";
        }, 600);
    }
};
InputSignsture = tslib_1.__decorate([
    Component({
        name: "input-signsture",
        components: {
            Signatrue
        }
    })
], InputSignsture);
export default InputSignsture;
